<button
  mat-stroked-button
  class="datepicker-toggle"
  (click)="toggleDropdown()"
  #datepickerDropdownToggle="cdkOverlayOrigin"
  cdkOverlayOrigin
>
  <div class="button-content-wrapper">
    <div class="date-container">
      <ng-container *ngIf="dateRangeDisplay; else noDateRange">
        <div class="selected-date-period-value" *ngIf="periodDisplay$ | async as display">
          {{ display | translate }}
        </div>
        <div class="selected-date-range-value">
          {{ dateRangeDisplay.range ?? '' | translate }}
        </div>
      </ng-container>
      <ng-template #noDateRange>
        <span>{{ 'GALAXY.DATE_RANGE.NO_PERIOD' | translate }}</span>
      </ng-template>
    </div>
    <mat-icon aria-hidden="false" aria-label="Date range">date_range</mat-icon>
  </div>
</button>
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="datepickerDropdownToggle"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayPositions]="_positions"
  [cdkConnectedOverlayBackdropClass]="showBackdrop ? '' : 'cdk-overlay-transparent-backdrop'"
  (backdropClick)="onBackdropClick()"
>
  <mat-card class="date-range-container">
    <mat-card-content>
      <div class="selected-ranges-header">
        <div class="selected-date-range">
          <div class="date-range-title">
            {{ 'GALAXY.DATE_RANGE.SELECTED_DATE_RANGE' | translate }}
          </div>
          <div *ngIf="dateRange && dateRange.start && dateRange.end; else noDateRange">
            {{ formatDateRange(dateRange) }}
          </div>
          <ng-template #noDateRange>
            <span>{{ 'GALAXY.DATE_RANGE.NO_PERIOD' | translate }}</span>
          </ng-template>
        </div>

        <div *ngIf="comparison" class="selected-date-range-comparison">
          <div class="date-range-title">
            {{ 'GALAXY.DATE_RANGE.COMPARE_TO' | translate }}
          </div>
          <div *ngIf="comparisonDateRange; else noComparisonDateRange">
            {{ formatDateRange(comparisonDateRange) }}
          </div>
          <ng-template #noComparisonDateRange>
            <span>{{ 'GALAXY.DATE_RANGE.NO_PERIOD' | translate }}</span>
          </ng-template>
        </div>
      </div>

      <mat-radio-group class="period-selector-container" [(ngModel)]="selectedPeriod">
        <ng-container *ngFor="let period of DATE_RANGE_PERIODS">
          <mat-radio-button
            class="period-select"
            color="primary"
            [value]="period.id"
            (change)="handleOnPeriodChange($event.value)"
          >
            {{ period.name | translate }}
          </mat-radio-button>
          <ng-template *ngIf="period.id === 7 && selectedPeriod === 7" [ngTemplateOutlet]="monthSelect"></ng-template>
          <ng-template *ngIf="period.id === 8 && selectedPeriod === 8" [ngTemplateOutlet]="quarterSelect"></ng-template>
          <ng-template
            *ngIf="period.id === 1 && selectedPeriod === 1"
            [ngTemplateOutlet]="dateRangeSelect"
          ></ng-template>
        </ng-container>
      </mat-radio-group>
    </mat-card-content>

    <mat-card-actions class="date-range-selector-actions">
      <button mat-stroked-button (click)="closeDropdown()">
        {{ 'GALAXY.DATE_RANGE.CANCEL' | translate }}
      </button>
      <button mat-flat-button color="primary" (click)="handleOnApply()" [disabled]="!dateRange">
        {{ 'GALAXY.DATE_RANGE.APPLY' | translate }}
      </button>
    </mat-card-actions>
  </mat-card>
</ng-template>

<ng-template #monthSelect>
  <div class="double-select-container">
    <glxy-select-input dense [formControl]="selectedMonthControl" [options]="monthOptions"></glxy-select-input>
    <glxy-select-input dense [formControl]="selectedMonthYearControl" [options]="yearOptions"></glxy-select-input>
  </div>
</ng-template>

<ng-template #quarterSelect>
  <div class="double-select-container">
    <glxy-select-input dense [formControl]="selectedQuarterControl" [options]="quarterOptions"></glxy-select-input>
    <glxy-select-input dense [formControl]="selectedQuarterYearControl" [options]="yearOptions"></glxy-select-input>
  </div>
</ng-template>

<ng-template #dateRangeSelect>
  <glxy-datepicker
    [selection]="'range'"
    (dateSelected)="onDateRangeChange($event)"
    [dateRange]="dateRange"
  ></glxy-datepicker>
</ng-template>
